var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNismarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#939598;stroke:#939598;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nismarker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nismarker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,25.05a20,20,0,1,0,20,20,20,20,0,0,0-20-20M73.26,44.44C73.26,58.28,62.93,66,50,78.82,36.77,66.07,26.74,58.51,26.74,44.44a23.26,23.26,0,0,1,46.52,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNismarker);
export default __webpack_public_path__ + "static/media/nismarker.7c067436cffa5403b9bf22fdc72e9c7e.svg";
export { ForwardRef as ReactComponent };